export default "__VITE_ASSET__DQYXsDx4__"